/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { Asset } from '@wit/vtv-x-foundation-lib';

export enum RailType {
  RECOMMENDATIONS = 'RECOMMENDATIONS',
}

export interface Rail {
  id: number;
  title: string;
  assets: Asset[];
  type?: RailType; // === undefined, it's the default type
  channelId?: number;
  hasMore?: boolean;
  withCategories?: boolean;
  loadingAssets?: boolean;
  channelLogoUri?: string;
}
